"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseSignalREffect = void 0;
const hermes_channel_1 = __importDefault(require("hermes-channel"));
const react_1 = require("react");
const utils_1 = require("../utils");
function createUseSignalREffect(context) {
    const useSignalREffect = (event, callback) => {
        const callbackRef = (0, utils_1.useEvent)(callback);
        (0, react_1.useEffect)(() => {
            var _a;
            function _callback(args) {
                callbackRef(...args);
            }
            (_a = context.on) === null || _a === void 0 ? void 0 : _a.call(context, event);
            hermes_channel_1.default.on(event, _callback);
            return () => {
                var _a;
                (_a = context.off) === null || _a === void 0 ? void 0 : _a.call(context, event);
                hermes_channel_1.default.off(event, _callback);
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    };
    return useSignalREffect;
}
exports.createUseSignalREffect = createUseSignalREffect;
//# sourceMappingURL=hooks.js.map